import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Task } from '@tcc-mono/classifact/shared/data-access/models';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';

@Injectable({ providedIn: 'root' })
export class TaskService extends BaseService<Task> {

  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = '/api/tasks'
  }

}
